import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const cwoaddadvertisementSchema = Yup.object().shape({
    advertisementtype: Yup.string()
    .required(CommonMessages.advertisementtype_required)
    .notOneOf(['0'], CommonMessages.advertisementtype_required),
    assignedlocation: Yup.string()
        .required(CommonMessages.location_required)
        .notOneOf(['0'], CommonMessages.location_required),
    advertisementname: Yup.string()
    .required(CommonMessages.advertisementname_required),
    startDate: Yup.string()
    .required(CommonMessages.startDate_required),
    endDate: Yup.string()
    .required(CommonMessages.endDate_required),
    file: Yup.string().when('advertisementtype', {
        is: (val: string) => val !== '1', // Ensure val is a string
        then: (schema) => schema.required(CommonMessages.file_required),
        otherwise: (schema) => schema.notRequired(),
    }),
    advertisement_des: Yup.string().when('advertisementtype', {
        is: (val: string) => val === '1', // Ensure val is a string
        then: (schema) => schema.required(CommonMessages.advertisement_des_required),
        otherwise: (schema) => schema.notRequired(),
    }),
})